module.exports = __webpack_public_path__ + "static/img/animation2.63306e8.png";